import React, { Component } from "react";
import InternationalContext from "./InternationalContext";
import Payment from "../../images/payment.svg";
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT } from "../../const";
import moment from "moment";
import { RemoveFucntionObject } from "../../utils";
import Crypter from "../../utils/crypter";
const { REACT_APP_URL_2C2P_REDIRECT } = process.env;

const imgScale = {
  width: "24px",
  height: "24px",
};
const Icon = (props) => <img className={props.className} src={props.src} {...imgScale} />;

class InternationalStep5 extends Component {
  callBackAction;
  state = {
    isSubmitted: false,
  };
  constructor(props) {
    super(props);
  }

  render() {
    const { step1, step2, step3, step4, step5 } = this.context;
    const { start_date, end_date, counter, destinationCountry, usertype } = step1;
    const country = (destinationCountry || []).map((dc) => dc.label).join(", ");
    const { selectedPlan, planList } = step2;
    const planDetail = planList.filter((plan) => plan.id === selectedPlan)[0] || {};
    const { total } = planDetail;
    let totalAmount = total
    if (usertype != 2) {
      totalAmount = counter ? total * counter : total;
    }
    const { isSubmitted } = this.state;
    // payment
    const { paymentModel } = this.context.step5;
    const hash1 = Crypter.decode(paymentModel.hash1 || "") || "";
    const hashs = hash1.split(",");
    let ver, mer, cur;
    if (hashs && hashs.length === 3) {
      ver = hashs[0];
      mer = hashs[1];
      cur = hashs[2];
    }

    return (
      <div className="form-wrapper payment-wrapper">
        <div className="form-group d-flex flex-column flex-1 w-100">
          <div className="circle-bg">
            <Icon className="align-item-center w-100 payment-icon" src={Payment} />
          </div>
          <div className="form-group">
            <div className="payment-reactagle">
              <label className="text-center">ชำระเบี้ยประกัน</label>
              <br />
              <label className="text-center">การเดินทางต่างประเทศ</label>
            </div>
          </div>
          <div className="form-wrapper order-wrapper">
            <div className="form-group">
              <div className="form-group">
                <label>เลขที่ใบสั่งซื้อ</label>
                <label className="order-value">
                  {paymentModel.orderId}
                  {/* {counter === 1 ? paymentModel.propId : paymentModel.refNo}     */}
                </label>
                {/* condition: send propId whenever counter === 1 otherwise send refNo*/}
              </div>
              <div className="form-group">
                <label>วันที่เดินทาง</label>
                <label className="order-value">
                  {moment(start_date).format(DATETHAI_FORMAT)} - {moment(end_date).format(DATETHAI_FORMAT)}
                </label>
              </div>
              <div className="form-group">
                <label>ประเทศปลายทาง</label>
                <label className="order-value">{country}</label>
              </div>
              <div className="form-group">
                <div className="totalPrice-wrapper d-flex flex-column align-item-center justify-content-center">
                  <label>ยอดรวมที่ต้องชำระ</label>
                  <label className="order-value">{CurrencyUtils.currency(totalAmount)} บาท</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-wrapper text-center">
            <button
              className="btn-primary align-item-center payment-btn"
              onClick={() =>
                this.setState({ isSubmitted: true }, () => {
                  localStorage.setItem("states_inter", this.getStepFromContext());
                  setTimeout(() => {
                    document.getElementById("submitBtn").click();
                  }, 1000);
                })
              }
            >
              ชำระเบี้ยเต็มจำนวน
            </button>
          </div>
        </div>
        {isSubmitted && (
          <form
            id="myform"
            className="d-none"
            method="post"
            action={REACT_APP_URL_2C2P_REDIRECT}
          >
            <input type="hidden" name="version" value={ver} />
            <input type="hidden" name="merchant_id" value={mer} />
            <input type="hidden" name="currency" value={cur} />
            <input type="hidden" name="result_url_1" value={paymentModel.returnUrl} />
            <input type="hidden" name="hash_value" value={paymentModel.hashValue} />
            <input type="hidden" name="payment_description" value={paymentModel.paymentDescription} />
            <br />
            <input type="hidden" name="order_id" value={paymentModel.orderId} />
            {/* <input type="hidden" name="order_id" value={counter === 1 ? paymentModel.propId : paymentModel.refNo}/> send refNo on order_id field */}
            <br />
            <input type="hidden" name="amount" value={paymentModel.paymentAmount} />
            <br />
            <input id="submitBtn" type="submit" name="submit" value="Confirm" />
          </form>
        )}
      </div>
    );
  }
  getStepFromContext() {
    let { step1, step2, step3, step4, step5, diffDate } = this.context;
    step1 = RemoveFucntionObject(step1);
    step2 = RemoveFucntionObject(step2);
    step3 = RemoveFucntionObject(step3);
    step4 = RemoveFucntionObject(step4);
    step5 = RemoveFucntionObject(step5);

    const data = JSON.stringify({
      step1,
      step2,
      step3,
      step4,
      step5,
      diffDate,
    });

    return Crypter.encode(data);
  }
}

InternationalStep5.contextType = InternationalContext;
export default InternationalStep5;
